import React, { Component } from "react";

import {
  likeRecommendation,
  removeLikeRecommendation
} from "../../helper/recommendation_helper";

import Like from "../../design/img/yaystack-icon-orange.png";
import NotLike from "../../design/img/yaystack-icon.png";

class LikeRecommendation extends Component {
  state = {};
  constructor(props) {
    super(props);
    this.state = {
      like: props.recommendation.like
    };
  }

  componentWillUnmount() {
    if (this.recommendationLike) {
      this.recommendationLike.cancel();
    }
    if (this.recommendationRemoveLike) {
      this.recommendationRemoveLike.cancel();
    }
  }

  render() {
    var image = NotLike;
    if (this.state.like === true) {
      image = Like;
    }

    // if (this.props.recommendation.)can_like false
    // json.like false
    return (
      <div className="share-button ">
        <div className="comment_number_icon" onClick={this.handlerLike}>
          <img
            src={image}
            alt="Like"
            width="32px"
            style={{ top: "6px", position: "absolute", left: "0px" }}
          />
          {/* <FontAwesomeIcon icon={faHeart} /> */}
        </div>
      </div>
    );
  }

  handlerLike = e => {
    if (this.props.recommendation.can_like === false) {
      //Push To Profile View
      this.props.history.push("/profile");
      return;
    }
    const self = this;
    if (this.state.like === true) {
      this.recommendationRemoveLike = removeLikeRecommendation(
        this.props.recommendation.id
      );
      this.recommendationRemoveLike.promise.then(answer => {
        self.setState({ like: false });
        if (self.props.handlerLikeRecommendation) {
          self.props.handlerLikeRecommendation(
            self.props.recommendation,
            false
          );
        }
      });
    } else {
      this.recommendationLike = likeRecommendation(
        this.props.recommendation.id
      );
      this.recommendationLike.promise.then(answer => {
        self.setState({ like: true });
        if (self.props.handlerLikeRecommendation) {
          self.props.handlerLikeRecommendation(self.props.recommendation, true);
        }
      });
    }
  };
}

export default LikeRecommendation;



// WEBPACK FOOTER //
// ./src/components/recommendation/like_recommendation.jsx